module.exports = __webpack_public_path__ + "static/media/logo_evolucione@2x.2e03c5c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo_evolucione@2x.png
// module id = 73
// module chunks = 0